export default __webpack_public_path__ + "static/media/guy_in_office.d673ec08.png";